import { Box, Button, Divider, Typography } from '@mui/material';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import DialogBox from '../Dialog Box/Dialog Box';
import Drawer from '../Drawer/Drawer';

const STEP_ITEMS = [
	{
		icon: VpnKeyOutlinedIcon,
		title: 'Register',
		desc: 'Sign up onto Finvu AA, an RBI Licensed Account Aggregator using your mobile number or handle.',
	},
	{
		icon: LinkOutlinedIcon,
		title: 'Select Accounts',
		desc: 'Add & choose which bank accounts you want to share. You stay in control, only selected accounts are shared.',
	},
	{
		icon: GppGoodOutlinedIcon,
		title: 'Approve Consents',
		desc: 'Review the details shared and for how long. Approve to share your data securely.',
	},
];

function StepperInfoContent({ customDetails, isDark, onClose }) {
	return (
		<>
			<Typography
				sx={{
					fontWeight: 700,
					fontSize: '1rem',
					lineHeight: 1.4,
					mb: '1.25rem',
					fontFamily: customDetails?.fontFamily,
					color: isDark ? '#fff' : '#000',
				}}
			>
				Sharing data securely to lenders through Account Aggregator in 3 easy steps
			</Typography>
			{STEP_ITEMS.map((step, i) => {
				const Icon = step.icon;
				return (
					<Box key={i} sx={{ mb: '1.25rem' }}>
						<Box sx={{ mb: '0.375rem' }}>
							<Icon sx={{ fontSize: '1.5rem', color: isDark ? '#aaa' : '#444' }} />
						</Box>
						<Typography
							sx={{
								fontWeight: 700,
								fontSize: '0.9375rem',
								fontFamily: customDetails?.fontFamily,
								color: isDark ? '#fff' : '#000',
								mb: '0.25rem',
							}}
						>
							{step.title}
						</Typography>
						<Typography
							sx={{
								fontSize: '0.875rem',
								fontFamily: customDetails?.fontFamily,
								color: isDark ? '#aaa' : '#555',
								lineHeight: 1.5,
							}}
						>
							{step.desc}
						</Typography>
					</Box>
				);
			})}
			<Divider
				sx={{
					mt: '1.5rem',
					mb: '1.5rem',
					mx: { xs: '-1.5rem', md: '-1.5rem' },
					width: 'calc(100% + 3rem)',
				}}
			/>
			<Button
				variant="contained"
				fullWidth
				size="large"
				onClick={onClose}
				sx={{
					padding: '10px 0',
					borderRadius: '6px',
					backgroundColor: customDetails?.primaryColor,
					color: customDetails?.ctaTextColor ?? '#fff',
					textTransform: 'capitalize',
					fontFamily: customDetails?.fontFamily,
					boxShadow: 'none',
					'&:focus-visible': { outline: 'none', boxShadow: 'none' },
					'&:hover': {
						backgroundColor: customDetails?.primaryColor,
						opacity: 0.9,
						boxShadow: 'none',
					},
				}}
			>
				Understood
			</Button>
		</>
	);
}

function StepperInfoDialog({ open, onClose, customDetails, isMobile, isDark }) {
	if (isMobile) {
		return (
			<Drawer
				open={open}
				setOpen={(isOpen) => !isOpen && onClose()}
				anchor="bottom"
				height="auto"
				customDetails={customDetails}
				showCloseBtn={false}
			>
				<Box
					sx={{
						backgroundColor: isDark
							? '#161616'
							: customDetails?.secondaryColor || '#fff',
						fontFamily: customDetails?.fontFamily,
						px: '1.5rem',
						pt: '1.5rem',
						pb: '1.5rem',
					}}
				>
					<Box sx={{ maxHeight: '55vh', overflowY: 'auto' }}>
						<StepperInfoContent
							customDetails={customDetails}
							isDark={isDark}
							onClose={onClose}
						/>
					</Box>
				</Box>
			</Drawer>
		);
	}

	return (
		<DialogBox
			open={open}
			handleClose={onClose}
			boxPadding="1.5rem"
			customDetails={customDetails}
		>
			<StepperInfoContent
				customDetails={customDetails}
				isDark={isDark}
				onClose={onClose}
			/>
		</DialogBox>
	);
}

export default StepperInfoDialog;
